// removed by extract-text-webpack-plugin
module.exports = {"header":"header__3QGkI","active":"active__3gItZ"};


//////////////////
// WEBPACK FOOTER
// ./components/header/style.css
// module id = u3et
// module chunks = 0